export const CUSTOM_PACKAGE_SKU = process.env.NEXT_PUBLIC_PACKAGE_SKU;

export const CART_MAX_AGE_SECONDS = 60 * 60 * 24 * 30;

export const existentUserError =
    "A customer with the same email address already exists in an associated website.";
